import { useCallback, useMemo, useRef } from "react"

import { useLocation, useRoute, useSearch } from "wouter"

import {
  DEFAULT_RESORT_SLUG,
  getExternalIdFromSlug,
  getSlugFromExternalId,
} from "@/utils/resortSlugMap"

export const DEFAULT_SELECTED_RESORT_EXTERNAL_ID = 1 // Sälen

const useResortParam = () => {
  const [match, params] = useRoute("/:resort")
  const [, navigate] = useLocation()
  const search = useSearch()

  const resortSlug = match ? params.resort : undefined
  const resortExternalId = useMemo(
    () =>
      (resortSlug ? getExternalIdFromSlug(resortSlug) : undefined) ??
      DEFAULT_SELECTED_RESORT_EXTERNAL_ID,
    [resortSlug]
  )

  const isValidResort =
    resortSlug !== undefined && getExternalIdFromSlug(resortSlug) !== undefined

  const searchRef = useRef(search)
  searchRef.current = search

  const setResortExternalId = useCallback(
    (id: number) => {
      const newSlug = getSlugFromExternalId(id) ?? DEFAULT_RESORT_SLUG
      const query = searchRef.current ? `?${searchRef.current}` : ""
      navigate(`/${newSlug}/${query}`, { replace: true })
    },
    [navigate]
  )

  return { resortExternalId, setResortExternalId, resortSlug, isValidResort }
}

export default useResortParam
